<template>
    <div id="scanner_setting_groups">
        <div class="ui doubling five column grid setting_groups"
            style="margin-top:0.1rem; margin-bottom:0.2rem;color:white;">
            <Group
                v-for="setting_group in setting_groups"
                v-if="!setting_group.is_hide && (
                    setting_group.key == 'search' ||
                    setting_group.key == 'print' ||
                    setting_group.key == 'any_number_to_label'
                )"
                :key="setting_group.key"
                :class="{'inverted': is_inverted}"
                :setting_group="setting_group"
                >
            </Group>

        </div>
    </div>
</template>

<script>
import Group from './group.vue'

export default {
    components: {
        Group
    },
    props: {
        is_inverted: {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
            is_setting: false,
        }
    },
    computed: {
        current_store() {
            return this.$store.state[this.$store.state.current_scope].scanner_module
        },
        setting_groups() {
            return this.current_store.setting_groups
        },
    },
    watch: {
    },
    mounted() {
    },
    methods: {
    },
}
</script>

<style lang="scss" scoped>
    #scanner_setting_groups {
        padding: .5833em .833em;
    }

    @media only screen and (max-width: 767px) {
        #scanner_setting_groups {
            max-height: 60vh;
            overflow-x: hidden;
            overflow-y: scroll;
        }
    }
</style>
